{
  "accessibilityLink": "Saavutettavuusseloste",
  "accessibilityPage": "Saavutettavuusseloste",
  "addComment": "Kirjoita kommentti",
  "addCommentAndVote": "Äänestä ja kommentoi",
  "addedFavorites": "Kuuleminen lisätty suosikkeihin.",
  "addFavorites": "Lisää suosikkeihin",
  "addGeojson": "Lisää geojson tiedostona",
  "addGeojsonInfo": "Huomaa että GeoJSON-formaatissa käytetään wgs84-koordinaatistoa. Tallenna tiedostoon vain yksi aluerajaus.",
  "addOption": "Lisää vastausvaihtoehto",
  "addProcess": "Lisää uusi vaihe",
  "addSection": "Lisää osa-alue",
  "additionalInfo": "Lisätiedot",
  "adminFilterSelectorLabel": "Suodata kuulemisia",
  "adminCommentMessage": "Olet kirjautuneena pääkäyttäjänä. Nimesi ja organisaatiosi näytetään kommenttisi yhteydessä",
  "all": "Kaikki",
  "allHearings": "Kaikki kuulemiset",
  "alreadyFavorite": "Kuuleminen kuuluu ennestään suosikkeihin.",
  "alreadyVoted": "Olet jo antanut äänesi tälle kommentille.",
  "alreadyFlagged": "Tämä kommentti on jo liputettu.",
  "anonymous": "Anonyymi",
  "APICallFailed": "Jokin meni pieleen. Kokeile pian uudestaan tai päivitä selain.",
  "asOpenData": "avoimena datana",
  "attachment": "Liite",
  "attachments": "Liitteet",
  "backToHearingMain": "Takaisin kuulemisen etusivulle",
  "borough": "Alue",
  "cancel": "Peru",
  "characters": "merkkiä",
  "clear": "Tyhjennä",
  "close": "Sulje",
  "closedCount": "Sulkeutuneet ({n})",
  "closedHearing": "Suljettu",
  "closeHearing": "Sulje kuuleminen",
  "commentConditions": "Annetut kommentit julkaistaan {linkToDefinition} palvelussa {linkToLicense}. Tekstejä voidaan muokata loukkaavan tai muutoin törkeän kielenkäytön osalta.",
  "commentDeleted": "Kommenttisi on poistettu.",
  "commentEdited": "Kommenttisi on muokattu. Kiitos!",
  "commentFlagged": "Kommentti liputettu.",
  "commentHearingStatus": "Kuulemisen tila: ",
  "commentHelpAnswerOrCommentRequired": "Vastaa vähintään yhteen kysymykseen tai kirjoita kommentti.",
  "commentHelpNoPersonalInfo": "Ethän jätä henkilötietoja kommenttiisi.",
  "commentHelpStarRequired": "Tähdellä (*) merkityt kentät ovat pakollisia.",
  "commentImageAlt": "Kommentoijan lisäämä kuva",
  "commentMapAdditionalInfo": "Lisätietoja karttaan liittyen (esim. osoite)",
  "commentMapTitle": "Merkitse ehdotuksesi kartalle",
  "commentMapInstructions": "Voit merkitä ehdotuksesi valitsemalla merkintätavan ja sen jälkeen merkitsemällä alueen. Voit poistaa merkintäsi napsauttamalla roskakoria ja sitten 'Tyhjennä kaikki'.",
  "commentOrder": "Järjestä kommentit:",
  "commentReceived": "Kommenttisi on vastaanotettu. Kiitos!",
  "commentRegisteredUsersOnly": "Kirjaudu sisään kommentoidaksesi.",
  "commentReportsButtonLabel": "Raportit",
  "commentReportsClose": "Sulje",
  "commentReportsDownload": "Lataa",
  "commentReportsSelectFileType": "Valitse tiedostotyyppi",
  "commentReportsTitle": "Kommenttiraportit",
  "commentVoting": "Kommenttien äänestys",
  "commentOrAnswerRequiredError": "Vastaa vähintään yhteen kysymykseen tai kirjoita kommentti.",
  "commentRequiredError": "Kirjoita kommentti ennen lähettämistä.",
  "comments": "Mielipiteet",
  "sectionCommentDeletedMessage": "Viesti on poistettu{date}, koska se ei noudattanut Kerrokantasi-palvelun sääntöjä. https://kerrokantasi.hel.fi/info",
  "sectionCommentGenericDeletedMessage": "Viesti on poistettu.",
  "sectionCommentSelfDeletedMessage": "Kirjoittaja poisti oman viestinsä.",
  "sectionCommentEditedMessage": "Kirjoittaja on muokannut viestiä.",
  "sectionCommentModeratedMessage": "Viestiä on muokattu, koska se rikkoi palvelun käyttöohjeita. https://kerrokantasi.hel.fi/info",
  "commentShowMap": "Karttamerkintä lisätty. Näytä kartta",
  "commentsOnMap": "Kartta koko näytöllä",
  "commentsOutOf": "Näytetään {current}/{total} kommenttia.",
  "commentStrongRegisteredUsersOnly": "Kirjaudu sisään Suomi.fi-tunnistuksella kommentoidaksesi.",
  "commentSubsectionBtn": "Kommentoi",
  "commentAndVoteSubsectionBtn": "Äänestä ja kommentoi",
  "contactPersons": "Yhteyshenkilöt",
  "contactPersonOrganizationHelpText": "Jos organisaatiota ei ole määritelty, sinun organisaatiotasi käytetään oletuksena.",
  "contactPersonAdditionalInfoHelpText": "Yritys/Taho, johon yhteyshenkilö kuuluu. Näytetään käyttäjille organisaation nimen sijaan, mikäli organisaatioksi on valittu `Kaupungin ulkopuoliset toimijat`",
  "contactTitle": "Virkanimike tai tehtäväkuvaus",
  "contactTitlePlaceholder": "Anna yhteyshenkilön virkanimike tai tehtävänkuvaus...",
  "cookieManagementLink": "Evästeasetukset",
  "copyHearing": "Kopioi kuuleminen",
  "copyrightHolder": "Kerrokantasi",
  "copyrightText": "Kaikki oikeudet pidätetään.",
  "create": "Luo",
  "createContact": "Luo uusi yhteyshenkilö",
  "CREATED_AT_ASC": "Vanhin ensin",
  "CREATED_AT_DESC": "Uusin ensin",
  "createHearing": "Luo uusi kuuleminen",
  "createLabel": "Luo uusi asiasana",
  "dataProtection": "Tietosuoja",
  "defaultClosureInfo": "Tämä kuuleminen on sulkeutunut. Mielipiteiden antaminen ja kannattaminen ei enää ole mahdollista.",
  "defaultProject": "Lisää uusi projekti",
  "delete": "Poista",
  "deleteAttachment": "Poista liite",
  "deleteComment": "Poista kommentti",
  "deleteConfirmation": "Oletko varma, että haluat poistaa kommentin?",
  "deleteDraft": "Poista luonnos",
  "deleteQuestion": "Poista kysymys",
  "deleteSection": "Poista osio",
  "descriptionTag": "Kerro mielipiteesi. Tule mukaan kehittämään kaupunkia ja osallistu avoimiin kuulemisiin.",
  "disabledLink": "Epäaktiivinen linkki",
  "downloadReport": "Lataa yhteenveto kommenteista Excel-muodossa",
  "downloadFileError": "Tiedoston lataaminen epäonnistui",
  "draft": "Luonnos",
  "draftDeleted": "Luonnos poistettiin onnistuneesti",
  "draftNotPublished": "Luonnos, ei julkaistu",
  "drafts": "Luonnokset",
  "draftCount": "Luonnokset ({n})",
  "edit": "Muokkaa",
  "editContact": "Muokkaa yhteystietoa",
  "editHearing": "Muokkaa",
  "email": "Sähköposti",
  "employee": "Työntekijä",
  "errorSaveBeforeAttachment": "Tallenna ensin ja palaa sitten lisäämään liitteet",
  "eyeTooltip": "Tätä kuulemista ei ole julkaistu eikä se ole julkisesti nähtävissä.",
  "eyeTooltipOpens": "Tämä kuuleminen julkaistaan",
  "favoriteHearings": "Suosikkikuulemiset",
  "feedbackLinkText": "Anna palautetta",
  "feedbackPrompt": "Kerro kantasi -kehitysideat",
  "firstClosing": "Ensimmäisenä sulkeutuvat",
  "follow": "Seuraa",
  "footerLogoAlt": "Kerrokantasi logo",
  "formButtonAcceptAndAdd": "Hyväksy ja lisää",
  "formCheckErrors": "Korjaa lomakkeen virheet ensin",
  "fullscreenHeaderLogoAlt": "Kerrokantasi logo",
  "generalNo": "Ei",
  "generalYes": "Kyllä",
  "headerLogoAlt": "Kerrokantasi logo",
  "headerWriteCommentLink": "Kirjoita kommentti",
  "headerOpenFrontPageLinks": "Avaa Etusivun linkkivalikko",
  "hearing": "Kuuleminen",
  "hearingAvailable-en": "Hearing available",
  "hearingAvailable-fi": "Kuuleminen saatavilla",
  "hearingAvailable-sv": "Hörandet tillgängligt",
  "hearingAvailableInLang-en": "in English",
  "hearingAvailableInLang-fi": "suomeksi",
  "hearingAvailableInLang-sv": "på svenska",
  "hearingArea": "Jos kuuleminen ei koske koko kaupunkia, piirrä kuulemisen tarkka alue kartalle",
  "hearingCardComment": "Kommentti",
  "hearingCardComments": "Kommenttia",
  "hearingCardFullWidthComment": "Kommentti",
  "hearingCardFullWidthComments": "Kommenttia",
  "hearingClosed": "Sulkeutunut",
  "hearingClosingDate": "Sulkeutumispäivä",
  "hearingClosingTime": "Sulkeutumisaika",
  "hearingClosingTimePlaceholder": "Valitse...",
  "hearingClosureInfo": "Sulkeutumistiedote",
  "hearingCommenting": "Kommentointi",
  "hearingCommentingMap": "Karttamerkintä kommentoinnissa",
  "hearingCommentingMapChoice1": "Ei käytössä",
  "hearingCommentingMapChoice2": "Piste merkintä",
  "hearingCommentingMapChoice3": "Piste, neliö ja monikulmio merkinnät valittavissa",
  "hearingContacts": "Yhteyshenkilöt",
  "hearingContactsPlaceholder": "Valitse kuulemisen yhteyshenkilöt",
  "hearingFormHeaderContainsErrors": " - sisältää virheitä",
  "hearingFormHeaderStep0": "Virheet",
  "hearingFormHeaderStep1": "1. Kuulemisen perustiedot",
  "hearingFormHeaderStep2": "2. Sisältö",
  "hearingFormHeaderStep3": "3. Kartta",
  "hearingFormHeaderStep4": "4. Julkaisutiedot",
  "hearingFormHeaderStep5": "5. Hankkeen vaiheet",
  "hearingFormNext": "Jatka",
  "hearingLabels": "Asiasanat",
  "hearingLabelsPlaceholder": "Valitse kuulemiselle sopivat asiasanat",
  "hearingLanguages": "Kuulemisen tiedot syötetään",
  "hearingListComment": "Kommentti",
  "hearingListComments": "Kommenttia",
  "hearingListNotPublished": "Julkaisematon kuuleminen,",
  "hearingMap": "Kuulemiset kartalla",
  "hearingMapHeaderText": "Kartta",
  "hearingNotFound": "Hakemaasi kuulemista ei löytynyt.",
  "hearingOnlyAvailableIn": "Kuuleminen saatavilla vain",
  "hearingOnlyAvailableInLang-en": "englanniksi",
  "hearingOnlyAvailableInLang-fi": "suomeksi",
  "hearingOnlyAvailableInLang-sv": "ruotsiksi",
  "hearingOpeningDate": "Avautumispäivä",
  "hearingOpeningTime": "Avautumisaika",
  "hearingPreviewLink": "Kopioi linkki",
  "hearingPreviewLinkFailed": "Linkin kopioiminen epäonnistui.",
  "hearingPreviewLinkSuccess": "Linkki kopioitu leikepöydälle.",
  "hearingPreviewLinkTooltip": "Kopioi esikatselulinkki leikepöydälle.",
  "hearings": "Kuulemiset",
  "hearingsHeaderText": "Kuulemiset",
  "hearingSlug": "Kuulemisen osoite (täytä osoitteen loppuosa)",
  "hearingSlugPlaceholder": "esimerkki-osoite",
  "hearingSubsectionsTitle": "Alaosiot",
  "hearingTranslationNotAvailable": "Tätä kuulemista ei ole julkaistu suomeksi",
  "help": "Ohjeet",
  "hideName": "Piilota nimi",
  "hideReplies": "Piilota vastaukset",
  "iframeAddButton": "Lisää iframe",
  "iframeFormFieldAllow": "Tietoturva yms. lisäasetukset (allow)",
  "iframeFormFieldHeight": "Korkeus pikseleinä (height)",
  "iframeFormFieldScrolling": "Vierityspalkki (scrolling)",
  "iframeFormFieldSrc": "Lähde (src)",
  "iframeFormFieldTitle": "Otsikko (title)",
  "iframeFormFieldWidth": "Leveys pikseleinä (width)",
  "iframeHtmlCopyPaste": "Iframe leikkaa ja liitä html",
  "iframeModalTitle": "Iframe tiedot",
  "imageAddButton": "Lisää kuva",
  "imageFileUploadError": "Jokin meni pieleen kuvan latauksessa.",
  "imageModalTitle": "Kuvan tiedot",
  "imageSizeError": "Kuva on liian suuri. Maksimikoko on 1 megatavu.",
  "infoHeaderText": "Tietoa palvelusta",
  "infoPage": "Tietoa palvelusta",
  "inLanguage-en": "englanniksi",
  "inLanguage-fi": "suomeksi",
  "inLanguage-sv": "ruotsiksi",
  "jumpToSearchForm": "Siirry hakulomakkeeseen",
  "jumpToSearchResults": "Siirry hakutuloksiin",
  "labelListTagsTitle": "Asiasanat",
  "labelPlaceholder": "Anna asiasanan nimi...",
  "lang-en": "English",
  "lang-fi": "Suomi",
  "lang-sv": "Svenska",
  "languageSwitchLabel": "Valitse sivuston kieli",
  "lastClosing": "Viimeisenä sulkeutuvat",
  "lastClosed": "Viimeisenä sulkeutuneet",
  "leastCommented": "Vähiten kommentoidut",
  "linkLeadsToExternal": "(Linkki johtaa ulkoiseen palveluun)",
  "list": "Lista",
  "login": "Kirjaudu",
  "loginAttemptFailed": "Kirjautuminen epäonnistui. Yritä hetken päästä uudelleen.",
  "logInToAnswer": "Kirjaudu sisään äänestääksesi ja katsoaksesi tuloksia",
  "loginToComment": "Kirjaudu sisään kommentoidaksesi.",
  "loginToContinue": "Kirjaudu sisään jatkaaksesi",
  "loginToVoteComment": "Kirjaudu sisään äänestääksesi kommenttia.",
  "logout": "Kirjaudu ulos",
  "mainSection": "Pääosio",
  "maintenanceNotificationLabel": "Palvelua päivitetään",
  "maintenanceNotificationText": "Uusi kirjautumistapa Helsinki-profiili otetaan käyttöön 15.5.",
  "maintenanceNotificationText2": "Google-, YLE-, Facebook-tunnistautumistavat poistuvat. Samalla työntekijöiden AD-tunnistautuminen muuttuu. Muutoksen jälkeen kirjautumiseen käytetään Helsinki-profiili-palvelua, jossa käyttäjät voivat jatkossa hallinnoida omia tietojaan kaupungin eri digipalveluissa. Helsinki-profiilin käyttöönoton myötä pääsy aiempiin omiin kirjautuneena tehtyihin kommentteihin katkeaa.",
  "maintenanceNotificationText3": "Muutoksen myötä myös työntekijöiden sisällöntuotanto-oikeudet poistuvat. Sisällöntuotannon osalta kannattaa varata aikaa sisällöntuotanto-oikeuksien uusimiseen.",
  "map": "Kartta",
  "mapView": "Kaikki kuulemiset kartalla",
  "mostCommented": "Eniten kommentoidut",
  "moveDown": "Siirrä alas",
  "moveUp": "Siirrä ylös",
  "multipleChoiceQuestion": "Monivalintakysymys (vastaaja voi valita useamman vaihtoehdon)",
  "name": "Nimi",
  "nameAndOrganization": "Nimi ja organisaatio",
  "newestFirst": "Uusimmat ensin",
  "newMultipleChoiceQuestion": "Lisää monivalintakysymys",
  "newSingleChoiceQuestion": "Lisää yksivalintakysymys",
  "next": "Seuraava",
  "nickname": "Nimimerkki",
  "noAddedComments": "Ei lisättyjä kommentteja",
  "noCommenting": "Ei kommentointia",
  "noCommentsAvailable": "Ei kommentteja",
  "noFavoriteHearings": "Ei lisättyjä suosikkeja",
  "noHearings": "Kuulemisia ei löytynyt",
  "noProject": "Ei projektia",
  "oldestFirst": "Vanhimmat ensin",
  "open-hearings-on-map": "Käynnissä olevat kuulemiset kartalla",
  "openCommenting": "Avoin kommentointi",
  "openVoting": "Avoin äänestäminen",
  "openCount": "Avoimet ({n})",
  "openFullscreenMap": "Kartta koko näytöllä",
  "openHearing": "Avoin",
  "openHearings": "Avoimet kuulemiset",
  "option": "Vastausvaihtoehto",
  "orderHasBeenChanged": "Kuulemisten järjestystä muutettu",
  "organization": "Organisaatio",
  "organizationHearings": "Organisaation kuulemiset",
  "ownHearings": "Omat kuulemiset",
  "partSection": "Osa-alue",
  "phase": "Hankkeen vaiheet",
  "phaseActive": "Kuuleminen kuuluu tähän vaiheeseen.",
  "phaseDescription": "Vaiheen kuvaus",
  "phaseDuration": "Vaiheen kesto",
  "phone": "Puhelinnumero",
  "pinnedComment": "Kiinnitetty julkaisu",
  "POPULARITY_ASC": "Vähiten suosittu ensin",
  "POPULARITY_DESC": "Suosituin ensin",
  "previous": "Edellinen",
  "project": "Hanke:",
  "projectName": "Projektin nimi",
  "projectSelection": "Jos kuuleminen kuuluu monivaiheiseen projektiin, valitse projekti tästä.",
  "published": "Julkaistu",
  "publishedHearings": "Julkiset",
  "publishHearing": "Hyväksy julkaistavaksi",
  "publishHearingNow": "Julkaise kuuleminen",
  "publishingQueue": "Julkaisujono",
  "question": "Kysymys",
  "questionHelpMulti": "Voit valita yhden tai useamman vaihtoehdon.",
  "questionHelpSingle": "Voit valita yhden vaihtoehdon.",
  "questionOptionPlaceholder": "Vastausvaihtoehdon teksti.",
  "questionTextPlaceholder": "Kirjoita tähän kysymys, johon haluat kaupunkilaisten vastaavan.",
  "queueCount": "Julkaisua odottavat ({n})",
  "register": "Rekisteröidy",
  "registered": "rekisteröitynyt",
  "registeredStrongOnly": "Vahvasti kirjautuneet käyttäjät ",
  "registeredUsersOnly": "Vain kirjautuneet käyttäjät",
  "registeredUserCommentMessage": "Nimesi tai nimimerkkisi näytetään kommenttisi yhteydessä. Voit poistaa nimen tai nimimerkin tyhjentämällä kyseisen kentän.",
  "removedFavorite": "Kuuleminen poistettu suosikeista.",
  "removeFavoriteNotFound": "Poistettavaa kuulemista ei löydy suosikeista.",
  "removeFavorites": "Poista suosikeista",
  "reply": "Vastaa",
  "revertPublishing": "Peru julkaisu",
  "save": "Tallenna",
  "saveAndPreviewHearing": "Tallenna ja tarkastele luonnosta",
  "saveFailed": "Tallentaminen epäonnistui",
  "saveHearingChanges": "Tallenna muutokset",
  "search": "Etsi",
  "searchLabels": "Hae aiheista",
  "searchPlaceholder": "Etsi...",
  "searchTitles": "Etsi otsikoista",
  "sectionAbstract": "Lyhyt johdanto",
  "sectionAbstractPlaceholder": "Kuvaa tässä pääasia lyhyesti. Näytetään alussa suuremmalla kirjasinkoolla kuin muu tekstisisältö.",
  "sectionCardSubsectionTitle": "Alaosio",
  "sectionContent": "Tekstisisältö",
  "sectionContentPlaceholder": "Varsinainen tekstisisältö, johon voit lisätä muotoiluja, linkkejä ja kuvia",
  "sectionImage": "Kuva",
  "sectionImageCaption": "Kuvateksti",
  "sectionImageHelpText": "Kuvan suosituskoko on 960 × 720 (Max. 1MB). Suuremmat kuvat skaalataan suosituskokoon.",
  "sectionImagePlaceholder": "Selitä tai täydennä kuvaa kuvatekstillä. Mainitse kuvaajan nimi, jos tarpeellista.",
  "sectionInformationTitle": "Tiedot",
  "sectionTitle": "Osa-alueen otsikko",
  "sectionTitlePlaceholder": "Lisää osa-alueelle kuvaava otsikko.",
  "sectionTotalComment": "{n} kommentti",
  "sectionTotalComments": "{n} kommenttia",
  "selectHearingComments": "Valitse tietyn kuulemisen kommentit",
  "selectOrDropFile": "Valitse tai pudota liite",
  "selectOrDropImage": "Valitse tai pudota kuva",
  "show": "Näytä",
  "showAll": "Näytä kaikki ({n})",
  "showMoreReplies": "Näytä vastaukset",
  "showOnlyOpen": "Näytetään vain avoimet",
  "showSubsectionBtn": "Näytä tiedot",
  "singleChoiceQuestion": "Yksivalintakysymys (vastaaja valitsee yhden vaihtoehdon)",
  "skipLinkAddButton": "Lisää hyppylinkki",
  "skipLinkFormFieldHide": "Piilota linkki",
  "skipLinkFormFieldOwnId": "Linkin oma id",
  "skipLinkFormFieldTargetId": "Linkin kohde id",
  "skipLinkFormFieldText": "Linkin teksti",
  "skipLinkModalTitle": "Hyppylinkin tiedot",
  "skipToMainContent": "Siirry pääsisältöön",
  "slugInUse": "Valitsemasi osoite oli käytössä ja siksi vaihdettiin.",
  "sort": "Järjestä",
  "scrollToTop": "Takaisin ylös",
  "submit": "Lähetä",
  "subsectionTitle": "Alaosio",
  "timeCloseFuture": "Sulkeutuu",
  "timeCloseFutureWithValues": "Sulkeutuu {date} klo {time}",
  "timeClosePast": "Sulkeutui",
  "timeClosePastWithValues": "Sulkeutui {date} klo {time}",
  "timeOpenFuture": "Avautuu",
  "timeOpenFutureWithValues": "Avautuu {date} klo {time}",
  "timeOpenPast": "Avautui",
  "timeOpenPastWithValues": "Avautui {date} klo {time}",
  "timetable": "Aikajana",
  "title": "Otsikko",
  "titlePlaceholder": "Anna kuulemiselle kuvaava otsikko...",
  "toBePublishedHearing": "Kuuleminen julkaistaan",
  "totalNumHearing": "{n} kuuleminen",
  "totalNumHearings": "{n} kuulemista",
  "totalQuestionVotes": "Ääniä yhteensä: {n}",
  "totalSubmittedComment": "Yhteensä {n} kommentti",
  "totalSubmittedComments": "Yhteensä {n} kommenttia",
  "toolbar": "Työkalupalkki",
  "tryingToDeletePhaseWithHearings": "Vaihetta, jossa on jo kuulemisia, ei voida poistaa.",
  "unpublishedAttachments": "Huom! Liitteet eivät ole ladattavissa, jos kuuleminen ei ole julkaistu.",
  "userInfo": "Omat tiedot",
  "userAddedComments": "Lisäämäni kommentit ({n} kpl)",
  "validationCantBeEmpty": "Tämä kenttä ei voi olla tyhjä",
  "validationHearingCloseAt": "Aseta sulkeutumisaika ennen tallentamista.",
  "validationHearingContactPersons": "Aseta ainakin yksi yhteyshenkilö.",
  "validationHearingLabels": "Aseta ainakin yksi asiasana.",
  "validationHearingOpenAt": "Aseta avautumisaika ennen tallentamista.",
  "validationHearingProjectPhaseActive": "Projektit tarvitsevat ainakin yhden aktiivisen vaiheen.",
  "validationHearingProjectPhaseTitle": "Aseta vaiheen otsikko ennen tallennusta.",
  "validationHearingProjectTitle": "Aseta projektin nimi ennen tallennusta.",
  "validationHearingSlug": "Aseta osoite ennen tallentamista.",
  "validationHearingTitle": "Aseta otsikko ennen tallentamista.",
  "validationNotification": "Lomake sisältää virheitä, tarkista virheet ja kokeile uudestaan.",
  "validationOnlyNumbers": "Tässä kentässä voi olla vain numeroita",
  "vote": "Äänestä",
  "voteButtonLikes": "Tykkäystä",
  "voteButtonText": "Tykkää tästä kommentista",
  "voteReceived": "Ääni vastaanotettu. Kiitos!",
  "welcome": "Kerro mielipiteesi",
  "welcomeMessage": "Tule mukaan kehittämään kaupunkia ja osallistu avoimiin kuulemisiin.",
  "withOpenLicense": "avoimella lisenssillä",
  "writeComment": "Kommentti",
  "externalContentBlocked": "Sisältöä ei voida näyttää",
  "externalContentBlockedDescription": "Tämä sisältö haetaan osoitteesta {url}. Sen näyttämiseen vaaditaan, että hyväksyt sivuston evästeet. Pääset näkemään sisällön joko siirtymällä ulkoiselle sivustolle tai sallimalla evästeasetuksista personointi- ja tilastointievästeet.",
  "openExternalSite": "Siirry ulkoiselle sivustolle",
  "editCookieSettings": "Muokkaa evästeasetuksia",
  "openExternalSiteAriaLabel": "Avaa {domain} uuteen ikkunaan",
  "editCookieSettingsAriaLabel": "Avaa evästeasetukset salliaksesi ulkoisen sisällön"
}
